export default __webpack_public_path__ + "static/media/190629_190332_IMG_E9623.3fd55735.jpg";